import React from "react";
import {
  displayNullFormatter,
  displayCommaFormatter,
  commonStyle,
  commonHeaderStyle,
  rowStyle2,
} from "../Utility/utility";
import "../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";

const View2AColumnsTable = (props) => {

    const { totalPagesView2A2B } = useSelector(
      (store) => store.gstr2a2bNewFetchReducer
    );

  const formatAmendmentType = (row) => {
    const atypValue = row?.FILE_JSON?.atyp;
    const normalizedAtyp =
      atypValue === null || atypValue === undefined
        ? ""
        : String(atypValue).trim().toUpperCase();

    if (normalizedAtyp === "R") return "Receiver GSTIN Amended";
    if (normalizedAtyp === "N") return "Invoice Number Amended";
    if (normalizedAtyp === "D") return "Details Amended";

    return displayNullFormatter(row.FILE_JSON, "atyp");
  };

  const View2AColumns = [
    {
      dataField: "INV_TYP",
      text: "Section Name",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "INV_TYP"),
    },
    {
      dataField: "USER_GSTN",
      text: "Taxpayer GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "USER_GSTN"),
    },

    {
      dataField: "RET_PERIOD",
      text: "Return Period",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RET_PERIOD"),
    },
    {
      dataField: "ctin",
      text: "GSTIN/ UIN of Counterparty",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
    
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "ctin"),
    },
    {
      dataField: "trdnm",
      text: "Name of Counterparty",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "trdnm"),
    },
    {
      dataField: "inum",
      text: "Invocie/ Document Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => {
        return row?.INV_TYP === 'CDN' || row?.INV_TYP === 'CDNA' ? '--' :
        displayNullFormatter(row.FILE_JSON, "inum")
      },
    },

    {
      dataField: "inv_typ",
      text: "Invoice Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      // formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "inv_typ"),
      formatter: (cell, row) => {
        return row?.INV_TYP === 'CDN' || row?.INV_TYP === 'CDNA' ? '--' :
        displayNullFormatter(row.FILE_JSON, "inv_typ")
      },
    },
    {
      dataField: "idt",
      text: "Invoice/ Document Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => {
        return row?.INV_TYP === 'CDN' || row?.INV_TYP === 'CDNA' ? '--' :
        displayNullFormatter(row.FILE_JSON, "idt")
      },
      // formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "idt"),
    },
    {
      dataField: "val",
      text: "Total Invoice",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => {
        return row?.INV_TYP === 'CDN' || row?.INV_TYP === 'CDNA' ? '--' :
        displayCommaFormatter(row.FILE_JSON, "val")
      },
      // formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "val"),
    },
    {
      dataField: "ntty",
      text: "Note Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => {
        return row?.INV_TYP !== 'CDN' && row?.INV_TYP !== 'CDNA' ? '--' :
        displayNullFormatter(row.FILE_JSON, "ntty")
      },
    },
    {
      dataField: "nt_num",
      text: "Note Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => {
        return row?.INV_TYP !== 'CDN' && row?.INV_TYP !== 'CDNA' ? '--' :
        displayNullFormatter(row.FILE_JSON, "nt_num")
      },
      // formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "nt_num"),
    },
    {
      dataField: "inv_typ",
      text: "Note Supply Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      //  formatter: (cell, row) => {
      //    return <span>'--'</span>;
      // },
      formatter: (cell, row) => {
        return row?.INV_TYP !== 'CDN' && row?.INV_TYP !== 'CDNA' ? '--' :
        displayNullFormatter(row.FILE_JSON, "suptyp")
      }
        ,


      // formatter: (cell, row) => {
      //   return row?.INV_TYP !== 'CDN' && row?.INV_TYP !== 'CDNA' ? '--' :
      //   displayNullFormatter(row.FILE_JSON, "ntty")
      // },
    },
    {
      dataField: "nt_dt",
      text: "Note Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      // formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "nt_dt"),
      formatter: (cell, row) => {
        return row?.INV_TYP !== 'CDN' && row?.INV_TYP !== 'CDNA' ? '--' :
        displayNullFormatter(row.FILE_JSON, "nt_dt")
      },
    },
    {
      dataField: "val",
      text: "Note Value",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      // formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "val"),
      formatter: (cell, row) => {
        return row?.INV_TYP !== 'CDN' && row?.INV_TYP !== 'CDNA' ? '--' :
        displayCommaFormatter(row.FILE_JSON, "val")
      },
    },
    {
      dataField: "oinum",
      text: "Original Invoice Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "oinum"),
    },
    {
      dataField: "oidt",
      text: "Original Invoice Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "oidt"),
    },
    {
      dataField: "ont_num",
      text: "Original Note Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "ont_num"),
    },
    {
      dataField: "ont_dt",
      text: "Original Note Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "ont_dt"),
    },
    {
      dataField: "pos",
      text: "Place of Supply",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "pos"),
    },
    {
      dataField: "rchrg",
      text: "Whether reverse charge is applicable",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "rchrg"),
    },
    {
      dataField: "rt",
      text: "Tax Rate",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "rt"),
    },
    {
      dataField: "txval",
      text: "Taxable Value",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "txval"),
    },
    {
      dataField: "iamt",
      text: "IGST Amount",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "iamt"),
    },
    {
      dataField: "camt",
      text: "CGST Amount",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "camt"),
    },
    {
      dataField: "samt",
      text: "SGST Amount",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "samt"),
    },
    {
      dataField: "csamt",
      text: "Cess Amount",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "csamt"),
    },
    {
      dataField: "cfs",
      text: "Counterparty Filing Status of GSTR1/5",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "cfs"),
    },
    {
      dataField: "fldtr1",
      text: "Date of filing GSTR1/5 of supplier",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "fldtr1"),
    },
    {
      dataField: "fail3",
      text: "Filing period of GSTR6 of supplier",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ret_period"),
    },
    {
      dataField: "fail4",
      text: "Applicable % of Tax Rate",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ret_period"),
    },
    {
      dataField: "fail5",
      text: "Original ISD Document Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ret_period"),
    },
    {
      dataField: "fail6",
      text: "Original ISD Document Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ret_period"),
    },
    {
      dataField: "fail7",
      text: "Original ISD Document Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ret_period"),
    },
    {
      dataField: "isd_docty",
      text: "ISD Document Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "isd_docty"),
    },
    {
      dataField: "docnum",
      text: "ISD Document Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "docnum"),
    },
    {
      dataField: "docdt",
      text: "ISD Document Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "docdt"),
    },

    {
      dataField: "flprdr1",
      text: "Filing period of GSTR1/5 of supplier",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "flprdr1"),
    },
    {
      dataField: "cfs3b",
      text: "GSTR3B filing status",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "cfs3b"),
    },
    // {
    //   dataField: "fail",
    //   text: "Original Tax Period",
    //   style: (cell, row, rowIndex, colIndex) => ({
    //     ...commonStyle,
    //   }),
    //   headerStyle: {
    //     ...commonHeaderStyle,
    //     width: "1.925%",
    //   },
    //   formatter: (cell, row) => displayNullFormatter(row, "ret_period"),
    // },
    {
      dataField: "atyp",
      text: "Amendment made, if any",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => formatAmendmentType(row),
    },
    {
      dataField: "aspd",
      text: "Tax Period in which Amended",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "aspd"),
    },
    {
      dataField: "refdt",
      text: "Reference date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "refdt"),
    },
    {
      dataField: "portcd",
      text: "Port Code",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "portcd"),
    },
    {
      dataField: "benum",
      text: "Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "benum"),
    },
    {
      dataField: "RET_PERIOD",
      text: "Tax Period",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RET_PERIOD"),
    },
    {
      dataField: "dtcancel",
      text: "Effective date of cancellation",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "dtcancel"),
    },
    {
      dataField: "srctyp",
      text: "Source",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "srctyp"),
    },
    {
      dataField: "irn",
      text: "IRN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "irn"),
    },
    {
      dataField: "irngendate",
      text: "IRN Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "irngendate"),
    },
    {
      dataField: "MATCH_MONTH",
      text: "Match Month",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => {
        // Show Match Month only when reconciliation status is 'Matched'
        if (!row || String(row.RECO_STATUS) !== "Matched") return "";
        return displayNullFormatter(row, "MATCH_MONTH");
      },
    },
    {
      dataField: "MARK_3B_MONTH",
      text: "Mark in 3B Month",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.925%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "MARK_3B_MONTH"),
    },
    {
      dataField: "RECO_STATUS",
      text: "Reco Status",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.825%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RECO_STATUS"),
    },
  ];
  return (
   <>
        <BootstrapTable
          keyField="ID"
          data={props.viewTableData}
          columns={View2AColumns}
          rowStyle={rowStyle2}
        />
        {/* <br />
        <ReactPaginate
          previousLabel={"previous"}
          nextLabel={"next"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={totalPagesView2A2B}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={props.handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
        /> */}
        </>
  );
};

export default View2AColumnsTable;
